// We can inject settings here
export const makeThirdPartyAppsMapper = () => (thirdPartyApp) => ({
  ...thirdPartyApp,
  isBlocked: false,
});

export default makeThirdPartyAppsMapper;
